import { Routes } from '@angular/router';
import { AuthGuard } from './core/helpers/auth.guard';

export const routes: Routes = [

  { path: '', pathMatch: 'full', redirectTo: 'home' },

  {
    path: 'home',
    //  canActivate: [AuthGuard],
    loadChildren: () => import('./module/home/home.module').then(m => m.HomeModule)
  },

  {
    path: 'order',
    loadChildren: () =>
      import('./module/order-form/order-form.module').then((o) => o.OrderFormModule),
  },
  {
    path: 'order/track',
    loadChildren: () =>
      import('./module/order-tracking/order-tracking.module').then((o) => o.OrderTrackingModule),
  },
  {
    path: 'order/display',
    loadChildren: () =>
      import('./module/order-display/order-display.module').then((o) => o.OrderDisplayModule),
  },
  {
    path: 'device/check',
    loadChildren: () =>
      import('./module/imei-check/imei-check.module').then((i) => i.ImeiCheckModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./module/sign-in/sign-in.module').then((s) => s.SignInModule),
  },
  { path: '**', pathMatch: 'full', redirectTo: '/' },
];
